import classNames from 'classnames';
import React, { useContext } from 'react';

import { RicosContext } from './../../../../../ricos-context';
import type { LogBiFn } from './../../../../../_shared/bi-context-provider/bi-context-provider';
import { ThumbnailPicker, usePanelContainerElement } from './../../../../../ui-components';

import type { ImageRatioSelector } from '../../../../common-types';
import {
  LAYOUT_SETTINGS_IMAGE_RATIO_THUMBNAIL,
  LAYOUT_SETTINGS_IMAGE_RATIO_THUMBNAIL_PICKER,
} from '../../../../data-hooks';
import classes from './image-ratio-control-scss';

type Props = {
  value: number;
  onChange: (value: number) => void;
  logBi: LogBiFn;
};

const dataSource: Record<
  ImageRatioSelector,
  {
    value: number;
    name: string;
    ratioClass: string;
  }
> = {
  '16-9': {
    value: 16 / 9,
    name: '16:9',
    ratioClass: classes.imageRatioSelector_16_9,
  },
  '4-3': {
    value: 4 / 3,
    name: '4:3',
    ratioClass: classes.imageRatioSelector_4_3,
  },
  '1-1': {
    value: 1,
    name: '1:1',
    ratioClass: classes.imageRatioSelector_1_1,
  },
  '3-4': {
    value: 3 / 4,
    name: '3:4',
    ratioClass: classes.imageRatioSelector_3_4,
  },
  '9-16': {
    value: 9 / 16,
    name: '9:16',
    ratioClass: classes.imageRatioSelector_9_16,
  },
};

export const ImageRatioControl: React.FC<Props> = ({ value, onChange, logBi }) => {
  const { t } = useContext(RicosContext);
  const containerEl = usePanelContainerElement();

  return (
    // @ts-expect-error
    <div style={{ '--ricos-thumbnail-picker-grid-columns': 5 }}>
      <ThumbnailPicker
        title={t('GallerySettings_Image_Ratio')}
        selectedValue={value}
        onChange={value => {
          logBi({ dataHook: LAYOUT_SETTINGS_IMAGE_RATIO_THUMBNAIL_PICKER, value });
          onChange(value as number);
        }}
        dataSource={Object.entries(dataSource).map(([ratio, { value, name, ratioClass }]) => ({
          value,
          dataHook: LAYOUT_SETTINGS_IMAGE_RATIO_THUMBNAIL + ratio,
          renderBackgroundImage: props => (
            <div
              {...props}
              className={classNames(classes.imageRatioSelector_ratioIcon, ratioClass)}
            />
          ),
          label: name,
        }))}
        tooltipAppendTo={containerEl}
        logBi={logBi}
        dataHook={LAYOUT_SETTINGS_IMAGE_RATIO_THUMBNAIL_PICKER}
      />
    </div>
  );
};
